import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

export interface deleteTransactionsByIdType {
  transaction_id: string;
  successCallback?: Function;
  errorCallback?: Function;
  resultKey?: string;
}

export default ({
  transaction_id,
  errorCallback,
  resultKey = 'deleteTransactionById',
  successCallback,
}: deleteTransactionsByIdType) =>
  requestAsync({
    url: endpoints.deleteTransactionsByIdUrl(transaction_id),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.deleteTransactionsByIdUrl(transaction_id),
    options: {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      authToken: true,
      errorCallback,
      successCallback,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
